import React, { useState, useEffect, useRef } from "react";
import '../../../../App.css';
import Fullsize from "../../../../assets/images/full-size.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalendarAlt, faChevronLeft, faChevronRight,
  faXmark, faBolt, faPaperclip, faChevronDown,
  faPlus, faMinus, faMagnifyingGlass, faArrowLeft, faPlane
} from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import { Button, Dropdown, Form, ProgressBar, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Timeline } from 'vis-timeline/standalone';
import 'vis-timeline/styles/vis-timeline-graph2d.min.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { TRUCKORDERSDETAILS } from '../../../../Utils/conts.js';

const Dashboard = () => {
  const isMounted = useRef(false);
  const childRef = useRef();
  const options = [];
  const [formData, setFormData] = useState();
  const [isOpened, setIsOpened] = useState(false);
  const [ucmOutText, setUcmOutText] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [ffmText, setFfmText] = useState('');
  const [showProcess, setShowProcess] = useState(false);
  const [processText, setProcessText] = useState('');
  const [cpmText, setCpmText] = useState('');


  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const handleSelect = date => {
    setSelectedDate(date);
    setShowCalendar(false); // Close the calendar when a date is selected

    // Update the timeline to display the selected date
    const timelineStart = new Date(date);
    timelineStart.setHours(0, 0, 0, 0); // Start of the day
    const timelineEnd = new Date(date);
    timelineEnd.setHours(23, 59, 59, 999); // End of the day

    if (timeline) {
      timeline.setOptions({
        start: timelineStart,
        end: timelineEnd,
      });
    }
    // END
    // Highlight the selected date in the custom calendar
    const calendar = document.querySelector('.scrollable-calendar');
    const days = calendar.querySelectorAll('.day');
    days.forEach((day) => {
      day.classList.remove('active');
    });

    const formattedDate = date.toISOString().split('T')[0];
    const matchingDay = Array.from(days).find((day) => {
      const dayDate = new Date(
        `${day.querySelector('.date').textContent}, ${new Date().getFullYear()}`
      );
      return dayDate.toISOString().split('T')[0] === formattedDate;
    });

    if (matchingDay) {
      matchingDay.classList.add('active');
    }
  };

  const [currentDate, setCurrentDate] = useState(new Date());
  const daysToShow = 7;

  function handleNext() {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() + daysToShow);
    setCurrentDate(newDate);
  }

  function handlePrevious() {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() - daysToShow);
    setCurrentDate(newDate);
  }

  function isCurrentDate(date) {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  }

  function getDayName(date) {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return days[date.getDay()];
  }

  function getMonthAbbreviation(date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[date.getMonth()];
  }

  const getStartDate = () => {
    const startDate = new Date(currentDate);
    startDate.setDate(currentDate.getDate() - 3); // 3 days before currentDate
    return startDate;
  };

  const handleDayClick = async (date, event) => {


    const calendar = document.querySelector('.scrollable-calendar');
    const days = calendar.querySelectorAll('.day');
    days.forEach(day => {
      day.classList.remove('active');
    });
    event.currentTarget.classList.add('active');

    const formattedDate = date.toISOString().split('T')[0];
    const dateObject = new Date(date);
    const datePart = dateObject.toISOString().split("T")[0];


    setSelectedDate(date);  // Store the selected date
    if (childRef.current) {
      childRef.current.handleCloseClick();
    }

    // Update the timeline
    const timelineStart = new Date(date);
    timelineStart.setHours(0, 0, 0, 0); // Start of the day
    const timelineEnd = new Date(date);
    timelineEnd.setHours(23, 59, 59, 999); // End of the day

    if (timeline) {
      timeline.setOptions({
        start: timelineStart,
        end: timelineEnd,
      });
    }
  };

  const [selectedButton, setSelectedButton] = useState('export');
  const handleButtonClick = (button) => {
    setSelectedButton(button);
  };

  // Frequency function Section Start
  const [frequentBooking, setFrequentBooking] = useState('O');
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // const updatedData = { ...frequentBooking, [name]: value };
    const updatedData = e.target.value;
    setFrequentBooking(updatedData);
    setFormData({
      ...formData,
      trip_type: updatedData
    });
  };
  // frequency Function End

  // tab
  // const storageData = JSON.parse(localStorage.getItem(''));
  // let storageTab = '';
  // if (storageData.msgtype) {
  //   if (storageData.msgtype === 'UCM OUT') {
  //     storageTab = 'UCM';
  //   } else {
  //     storageTab = storageData.msgtype
  //   }
  // } else {
  //   storageTab = 'UCM';
  // }

  // const storageMsg = storageData.message ? storageData.message : '63';
  const [activeTab, setActiveTab] = useState('info');
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const [selected, setSelected] = useState([]);

  const handleClick = (day) => {
    if (selected.includes(day)) {
      setSelected(selected.filter((d) => d !== day));
    } else {
      setSelected([...selected, day]);
    }
    const selectedDays = formData.selected_days.includes(day) ? formData.selected_days.filter(item => item !== day) : [...formData.selected_days, day];
    setFormData({
      ...formData,
      selected_days: selectedDays
    });
  };


  const handleCloseProcess = () => { setShowProcess(false); };
  const handleFullsizeClick = (event) => {
    event.preventDefault();
    setShowProcess(true);
  };

  const handleTextareaChange = (e) => {
    const { name, value } = e.target;

    // Update state based on the name of the textarea
    if (name === 'ucm_out') {
      setUcmOutText(value);
    } else if (name === 'ffm') {
      setFfmText(value);
    } else if (name === 'cpm') {
      setCpmText(value);
    } else if (name === 'process') {
      setProcessText(value);
    }
  };


  // TIMELINE START 

  const timelineRef = useRef(null);
  const svgRef = useRef(null);
  const [selectedFlightDetails, setSelectedFlightDetails] = useState();
  const [showFlightDetails, setShowFlightDetails] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);
  const [flightGroup, setFlightGroup] = useState([]);
  const [clickedFlight, setClickedFlight] = useState(null); // Store the clicked flight ID
  const [currentTime, setCurrentTime] = useState(new Date());
  const [timeline, setTimeline] = useState(null);
  const [timelineDisplay, setTimelineDisplay] = useState('T');
  const [getTruckData, setGetTruckData] = useState([]);
  const [disLoading, setDisLoading] = useState(false);
  const [connections, setConnections] = useState([]);
  const [getStation, setGetStation] = useState([]);
  const [selectedStation, setSelectedStation] = useState([]);





  const allItems = [
    {
      id: 1, group: 1, content: `<div>  <span> AMS - 142 </span>    <p> Export (Unloading) </p> </div>`, start: '2025-01-14 14:25', end: '2025-01-14 20:00', className: 'dashbord_blu', trucksList: [
        { id: 3, group: 1, content: `<div >  <span> AMS - 142 </span>    <p> Export (Unloading) </p> </div>`, start: '2025-01-14 14:25', end: '2025-01-14 24:00', className: 'dashbord_gray flight' },
        { id: 7, group: 1, content: `<div>  <span> AMS- 152A </span> <p> Export (Unloading) </p> </div>`, start: '2025-01-14 6:00', end: '2025-01-14 18:00', className: 'dashbord_blu truck' },
        { id: 8, group: 1, content: `<div>  <span> AMS - 612A </span> <p> Export (Unloading) </p>  <pre> BRU - AMS </pre> </div>`, start: '2025-01-14 8:00', end: '2025-01-14 8:00 20:00', className: 'dashbord_gr truck' },
        { id: 9, group: 1, content: `<div>  <span> AMS - 187 </span> <p> Export (Unloading)S </p>   <pre> BRU - AMS </pre> </div>`, start: '2025-01-14 10:00', end: '2025-01-14 17:00', className: 'dashbord_org truck' },
      ]
    },
    {
      id: 2, group: 2, content: `<div>  <span> AMS - 924 </span>    <p> Export (Unloading) </p> </div>`, start: '2025-01-14 14:25', end: '2025-01-14 17:35', className: 'bg-green', trucksList: [
        { id: 3, group: 2, content: '<div>  <span> AMS - 924 </span>    <p> Export (Unloading) </p>', start: '2025-01-14 14:50', end: '2025-01-14 20:15', className: 'bg-green' },
        { id: 7, group: 2, content: '<div> <span> AMS - 925B </span> <p> Export (Unloading) </p> </div>', start: '2025-01-14 15:00', end: '2025-01-14 18:00', className: 'bg-green' },
        { id: 8, group: 2, content: '<div> <span> AMS - 015A </span> <p> Export (Unloading) </p> </div>', start: '2025-01-14 16:00', end: '2025-01-14 19:00', className: 'bg-orange' },
      ]
    },
    {
      id: 3, group: 3, content: `<div>  <span> AMS - 272 </span>    <p> 14:50 - 20:15 </p> </div>`, start: '2025-01-14 14:50', end: '2025-01-14 20:15', className: 'dashbord_gr', trucksList: [
        { id: 3, group: 3, content: '<div> <span> AMS - 272 </span>    <p> 14:50 - 20:15 </p> </div>', start: '2025-01-14 14:50', end: '2025-01-14 20:15', className: 'dashbord_gray' },
        { id: 7, group: 3, content: '<div> <span> AMS - 015A </span> <p> 13:00 - 06:35 </p> </div>', start: '2025-01-14 15:00', end: '2025-01-14 18:00', className: 'dashbord_gr' },
        { id: 8, group: 3, content: '<div> <span> AMS - 015A </span> <p> 13:00 - 06:35 </p> </div>', start: '2025-01-14 16:00', end: '2025-01-14 19:00', className: 'dashbord_blu' },
      ]
    },
    {
      id: 4, group: 4, content: 'AMS - 129', start: '2025-01-14 14:05', end: '2025-01-14 20:15', className: 'bg-blue', trucksList: [
        { id: 3, group: 4, content: 'AMS - 129', start: '2025-01-14 14:50', end: '2025-01-14 20:15', className: 'bg-green' },
        { id: 7, group: 4, content: 'Truck 1 - Cargo', start: '2025-01-14 15:00', end: '2025-01-14 18:00', className: 'bg-green' },
        { id: 8, group: 4, content: 'Truck 2 - Cargo', start: '2025-01-14 16:00', end: '2025-01-14 19:00', className: 'bg-orange' },
      ]
    },
    {
      id: 5, group: 5, content: 'AMS - 156', start: '2025-01-14 15:55', end: '2025-01-14 23:30', className: 'bg-blue', trucksList: [
        { id: 3, group: 5, content: 'AMS - 156', start: '2025-01-14 14:50', end: '2025-01-14 20:15', className: 'bg-green' },
        { id: 7, group: 5, content: 'Truck 1 - Cargo', start: '2025-01-14 15:00', end: '2025-01-14 18:00', className: 'bg-green' },
        { id: 8, group: 5, content: 'Truck 2 - Cargo', start: '2025-01-14 16:00', end: '2025-01-14 19:00', className: 'bg-orange' },
      ]
    },
    {
      id: 6, group: 6, content: 'AMS - 815 ', start: '2025-01-14 20:30', end: '2025-01-14 23:40', className: 'bg-orange', trucksList: [
        { id: 3, group: 6, content: 'AMS - 815 ', start: '2025-01-14 14:50', end: '2025-01-14 20:15', className: 'bg-green' },
        { id: 7, group: 6, content: 'Truck 1 - Cargo', start: '2025-01-14 15:00', end: '2025-01-14 18:00', className: 'bg-green' },
        { id: 8, group: 6, content: 'Truck 2 - Cargo', start: '2025-01-14 16:00', end: '2025-01-14 19:00', className: 'bg-orange' },
      ]
    },
  ];

  const truckDetailsForFlight = [
    { id: 7, group: 'Truck 1', content: 'ZZZ-152A', start: '2025-01-14 05:00', end: '2025-01-14 20:25', flightId: 1, className: 'bg-green' },
    { id: 8, group: 'Truck 2', content: 'ZZZ-722B', start: '2025-01-14 02:00', end: '2025-01-14 21:35', flightId: 1, className: 'bg-green' },
    { id: 9, group: 'Truck 3', content: 'ZZZ-612A', start: '2025-01-14 13:00', end: '2025-01-14 06:35', flightId: 2, className: 'bg-blue' },
    { id: 10, group: 'Truck 4', content: 'ZZZ-422', start: '2025-01-14 07:00', end: '2025-01-14 16:05', flightId: 3, className: 'bg-green' },
    { id: 11, group: 'Truck 5', content: 'ZZZ-681A', start: '2025-01-14 09:00', end: '2025-01-14 20:10', flightId: 4, className: 'bg-green' },
    { id: 12, group: 'Truck 6', content: 'ZZZ-925B', start: '2025-01-14 20:15', end: '2025-01-14 05:25', flightId: 5, className: 'bg-blue' },
  ];


  const groups = [
    { id: 1, content: 'AMS' },
    { id: 2, content: 'FRA' },
    { id: 3, content: 'CDG' },
    { id: 4, content: 'LHR' },
    { id: 5, content: 'AAG' },
    { id: 6, content: 'CGO' },
  ];

  const truckGroups = [
    { id: 'Truck 1', content: 'Truck 1' },
    { id: 'Truck 2', content: 'Truck 2' },
    { id: 'Truck 3', content: 'Truck 3' },
    { id: 'Truck 4', content: 'Truck 4' },
    { id: 'Truck 5', content: 'Truck 5' },
    { id: 'Truck 6', content: 'Truck 6' },
  ];




  const drawConnections = () => {
    const svg = svgRef.current;
    if (!svg) return;

    svg.innerHTML = ""; // Clear previous SVG paths

    filteredItems?.forEach((item) => {
      // Find the flight element by its data-id
      const flightElement = document.querySelector(`.vis-item.flight`);
      if (!flightElement) {
        // console.warn(`Flight element with id flight-${item.id} not found`);
        return; // Skip drawing if the flight element is missing
      }

      const flightRect = flightElement.getBoundingClientRect();
      const flightX = flightRect.left; // X-coordinate of the left line
      const flightY = flightRect.top + flightRect.height / 2; // Middle of the left line

      // Iterate over the trucksList for this flight
      item.trucksList.forEach((truck, trindex) => {
        const truckElements = document.querySelectorAll('.vis-item.truck'); // All truck elements
        const truckElement = truckElements[trindex]; // Get the truck element corresponding to this index

        if (!truckElement) return;

        const truckRect = truckElement.getBoundingClientRect();
        const truckX = truckRect.left + truckRect.width;
        const truckY = truckRect.top + truckRect.height / 2;

        // Create an SVG path for each truck
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        const verticalOffset = Math.abs(flightY - truckY) / 10;
        const isPositive = truckY - flightY > 0;

        const pathData = isPositive
          ? `M ${flightX},${flightY} 
                           C ${flightX - 50},${flightY + verticalOffset} 
                             ${truckX + 50},${truckY + verticalOffset} 
                             ${truckX},${truckY}`
          : `M ${flightX},${flightY} 
                           C ${flightX - 50},${flightY - verticalOffset} 
                             ${truckX + 50},${truckY - verticalOffset} 
                             ${truckX},${truckY}`;

        path.setAttribute("d", pathData);
        path.setAttribute("fill", "none");
        path.setAttribute("stroke", "black");
        path.setAttribute("stroke-width", "2");

        svg.appendChild(path);
      });
    });
  };


  const [isDataReady, setIsDataReady] = useState(false);

  useEffect(() => {
    if (allItems && allItems.length > 0) {
      setIsDataReady(true);
    }
  }, [allItems]);

  useEffect(() => {
    if (timelineDisplay) {
      const timelineStart = new Date(currentTime);
      // timelineStart.setHours(timelineStart.getHours() - 8); // Show 2 hours before
      timelineStart.setHours(0, 0, 0, 0); // Show 2 hours before
      const timelineEnd = new Date(currentTime);
      // timelineEnd.setHours(timelineEnd.getHours() + 8);
      timelineEnd.setHours(23, 59, 59, 999);

      const innertimelineStart = new Date(currentTime);
      innertimelineStart.setHours(-20, 0, 0, 0); // Show 2 hours before
      const innertimelineEnd = new Date(currentTime);
      innertimelineEnd.setHours(23, 59, 59, 999);

      const options = {
        stack: true,
        margin: {
          item: 10, // Space between items
          axis: 10, // Space between items and the axis
        },
        start: showFlightDetails ? innertimelineStart : timelineStart,
        end: showFlightDetails ? innertimelineEnd : timelineEnd,
        editable: false,
        zoomable: true,
        horizontalScroll: true,
        itemHeight: 51,
        minHeight: '85dvh',
        orientation: { axis: 'both', item: 'bottom' }, // axis: 'both'/ 'top'/ 'bottom'
        zoomMin: showFlightDetails ? 1200000 : 86400000,
        zoomMax: 432000000 //31536000000
      };

      // const timeline = new Timeline(timelineRef.current, showFlightDetails ? filteredItems : allItems, showFlightDetails ? truckGroups : groups, options);
      const timeline = new Timeline(timelineRef.current, showFlightDetails ? filteredItems[0].trucksList : allItems, showFlightDetails ? [{ id: clickedFlight?.group, content: clickedFlight?.content, start: clickedFlight?.start, end: clickedFlight?.end }] : groups, options);

      // Handle item click event to show truck details for specific flight
      timeline.on('click', function (properties) {
        if (properties.item) {
          const clickedItem = allItems.find(item => item.id === properties.item);
          if (clickedItem) {

            setShowProcess(true);
          }
        }
      });



      timeline.on("changed", () => {
        requestAnimationFrame(drawConnections); // Ensure DOM rendering
      });

      setTimeout(() => {
        drawConnections(); // Initial drawing
      }, 200); // Delay to allow rendering



      setTimeline(timeline);
      return () => timeline.destroy();
    }


  }, [isDataReady, showFlightDetails, filteredItems, timelineDisplay]);



  const handleSidePanelClick = async (item) => {
    // console.log('item', item);
    if (!showFlightDetails) {
      if (timelineDisplay === 'F') {
        setSelectedFlightDetails(item);
      } else {
        setDisLoading(true);
        try {
          const res = await withRFSToken.post(TRUCKORDERSDETAILS, { order_id: item.order_id })
            .then(function (res) {
              const innerData = res.data.response_data;
              setSelectedFlightDetails(innerData);
              setDisLoading(false);
            });
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    }
  }

  const detailsClick = () => {

    setFilteredItems([selectedFlightDetails]);
    setShowFlightDetails(true);
    setClickedFlight(selectedFlightDetails);
    setSelectedFlightDetails(null);

    const fromId = selectedFlightDetails.trucksList[0]?.id;
    const toConnections = selectedFlightDetails.trucksList.slice(1).map((item) => ({
      from: fromId,
      to: item.id,
    }));



  }
  // console.log('timeline', timeline);
  const DisplayChange = (event) => {
    setShowFlightDetails(false);
    setFilteredItems(null);
    setTimelineDisplay(event.target.value);
    setSelectedFlightDetails()
  }
  const handleSortBy = (event) => {
    const sortBy = event.target.value;

  }


  // Helper function to find timeline item by content
  const findItemByContent = (container, content) => {
    const items = container.querySelectorAll(".vis-item");
    return Array.from(items).find((item) => item.textContent?.includes(content));
  };



  const zoomIn = () => {
    if (timeline) {
      const range = timeline.getWindow();
      const interval = range.end - range.start;
      timeline.setWindow({
        start: new Date(range.start.getTime() + interval * 0.1), // Zoom in 10%
        end: new Date(range.end.getTime() - interval * 0.1),
      });
    }
  };

  // Function to zoom out
  const zoomOut = () => {
    if (timeline) {
      const range = timeline.getWindow();
      const interval = range.end - range.start;
      timeline.setWindow({
        start: new Date(range.start.getTime() - interval * 0.1), // Zoom out 10%
        end: new Date(range.end.getTime() + interval * 0.1),
      });
    }
  };

  const updateCurrentTime = () => {
    setCurrentTime(new Date());
  };
  const handleCloseClick = () => {
    setSelectedFlightDetails(null);
  };



  // FILE UPLOAD START
  const [showModalUpload, setShowModalUpload] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [files, setFiles] = useState([]);
  const fileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);



  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files);
    setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    getBase64(droppedFiles[0]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    base64Files.splice(index, 1);
  };

  const handleBrowseFiles = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };
  // FILE UPLOAD END

  return (
    <>
      {console.log('allItems', selectedStation)}
      {/* {console.log('timeline', timeline)} */}
      {console.log('groups', groups)}
      <div className="dashboard">

        <div className="page-body-wrapper schedule">

          <div className="main-panel rounded">
            <div className="mainTab d-flex justify-content-between align-items-center">
              <div className="nestedtabs rounded">
                <div className='d-flex'>
                  <div>
                    <div style={{ position: 'relative' }}>
                      <div onClick={toggleCalendar} className='clendericon'>
                        <FontAwesomeIcon icon={faCalendarAlt} />
                      </div>
                      {showCalendar && (
                        <div style={{ position: 'absolute', top: '100%', left: 0, zIndex: 9999, }}>
                          <DatePicker
                            selected={selectedDate}
                            onChange={handleSelect}
                            inline
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="calendar-container schedule_calender">
                    <div className="scrollable-calendar">
                      <button className='btnleft' onClick={handlePrevious}> <FontAwesomeIcon icon={faChevronLeft} /> </button>
                      {[...Array(daysToShow)].map((_, index) => {
                        const date = new Date(getStartDate());
                        date.setDate(getStartDate().getDate() + index);
                        return (
                          <div key={index} className={`day ${isCurrentDate(date) ? 'current-date' : ''}`} onClick={(event) => handleDayClick(date, event)}>
                            <div className="day-name">{getDayName(date)}</div>
                            <div className="date"> {getMonthAbbreviation(date)} {date.getDate()}</div>
                          </div>
                        );
                      })}
                      <button className='btnright' onClick={handleNext}> <FontAwesomeIcon icon={faChevronRight} /> </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-end truck_filter">

                {/* <div className="d-flex tuck_short">

                  <Form.Group className="me-2">
                    <Form.Label>Display</Form.Label>
                    <Form.Select aria-label="Select" onChange={(event) => DisplayChange(event)}>
                      <option value="T">Truck</option>
                      <option value='F'>Flights</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group >
                    <Form.Label>Sort By</Form.Label>
                    <Form.Select aria-label="Select" onChange={(event) => handleSortBy(event)}>
                     
                      <option value="L">Loading Station</option>
                      <option value="U">Unloading Station</option>
                    </Form.Select>
                  
                  </Form.Group>


                </div> */}
                {/* <div className="ms-2"><button type="button" class="btn btn-primary truck_search" onClick={handleFilter}><FontAwesomeIcon icon={faMagnifyingGlass} /> Search</button></div> */}


                {/* <div className="chart_filter ms-2" > <Link to="#" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight2" aria-controls="offcanvasRight"> <img src={Filter} ></img> </Link> </div> */}

                {/* <div className="offcanvas offcanvas-end dashbord_side" tabindex="-1" id="offcanvasRight2" aria-labelledby="offcanvasRightLabel">
                  <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                  <div className="offcanvas-header rafilter">
                    <h3>Filter Properties</h3>
                    <p>Select Properties that you want to see inside the chart</p>
                  </div>
                  <div className="offcanvas-body">

                    <Form.Group className="mb-3 rasl_box" controlId="exampleForm.ControlInput1">
                      <Form.Label>Loading Station</Form.Label>
                      <Form.Select aria-label="Default select example">
                        <option>Open this select menu</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3 rasl_box" controlId="exampleForm.ControlInput1">
                      <Form.Label>Unloading Station</Form.Label>
                      <Form.Select aria-label="Default select example">
                        <option>Open this select menu</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Form.Group>


                    <Form.Group className="mb-3 rasl_box" controlId="exampleForm.ControlInput1">
                      <Form.Label>Trucker Name</Form.Label>
                      <Form.Select aria-label="Default select example">
                        <option>Open this select menu</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Form.Group>

                    <div className='text-center filter_update'>
                      <Button variant="light" className='stk_cancel' >CANCEL</Button>
                      <Button variant="primary" className='stk_save posr' >UPDATE</Button>
                    </div>
                  </div>
                </div> */}
                <div className="ms-2 truck_plas">
                  <button type="button" class="btn btn-light" onClick={zoomOut}> <FontAwesomeIcon icon={faMinus} /> </button>
                  <button type="button" class="btn btn-light ms-2" onClick={zoomIn}><FontAwesomeIcon icon={faPlus} /></button>

                </div>


              </div>
              {/* <CargoDamage />                        */}
            </div>
            {showFlightDetails && <Link to="#" onClick={() => setShowFlightDetails(false) && setFilteredItems(null)} className='stk_back mt-3 d-block'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>}
            <div className={`maindiv mt-3 overflow-hidden ${timelineDisplay == 'T' ? 'position-relative' : ''}`}>
              {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
              }
              <div className={`mb-0 nestedtabs rounded trashdonload ${timelineDisplay == 'F' ? 'clip-hide' : ''}`}>
                <div ref={timelineRef}></div>{/* style={{ height: '400px' }} */}

                {showFlightDetails && (
                  <>
                    {/* <Link to="#" className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link> */}
                    <svg ref={svgRef} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }} />
                    {/* <button onClick={() => setShowFlightDetails(false)} style={{ marginTop: '20px' }}>
                                            Back to All Flights
                                        </button> */}
                  </>
                )}
              </div>

              <div className="SecondDiv">










              </div>

            </div>
          </div>
        </div>

        <Modal show={showProcess} className='addfrom' onHide={handleCloseProcess} size="xl" centered>
          <Modal.Header closeButton>
            <Modal.Title>Door Planning</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <>
              <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="autometd">
                <Tab eventKey="info" title={<span>Info</span>} className='moveto'>
                  <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-center charter_top '>
                      <h3 className='mb-0' >Info...</h3>
                      <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                    </div>
                    <div style={{ height: '500px' }}></div>
                  </div>
                </Tab>
                <Tab eventKey="status" title={<span>Status</span>} className='moveto'>
                  <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-center charter_top '>
                      <h3 className='mb-0'>Status...</h3>
                      <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                    </div>
                    <div style={{ height: '500px' }}></div>
                  </div>
                </Tab>
                <Tab eventKey="trans" title={<span>Transaction Log</span>} className='moveto'>
                  <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-center charter_top '>
                      <h3 className='mb-0'>Transaction Log...</h3>
                      <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                    </div>
                    <div style={{ height: '500px' }}></div>
                  </div>
                </Tab>
                <Tab eventKey="attachments" title={<span>Attachments</span>} className='moveto'>
                  <div className='mt-3'>
                    <div className='d-flex justify-content-between align-items-center charter_top '>
                      <h3 className='mb-0'>Attachments...</h3>
                      <a href='#' className='zoom_up' onClick={handleFullsizeClick}>  <img src={Fullsize} /> </a>
                    </div>
                    <div style={{ height: '500px' }}></div>
                  </div>
                </Tab>
              </Tabs>
            </>


          </Modal.Body>
        </Modal>

      </div >



    </>
  )
}

export default Dashboard